import { findIndex } from 'lodash';
import DataFieldsDB from 'src/fb/dataFields-db';
import DataFieldSectionsDB from 'src/fb/dataFieldSections-db';
import { auth as useAuthStore } from 'src/store/auth';

export default {

  setClinicDataFields(dataFields) {
    this.clinicDataFields = dataFields;
  }, // setClinicDataFields()

  setClinicDataFieldSections(dataFieldSections) {
    this.clinicDataFieldSections = dataFieldSections;
  }, // setClinicDataFieldSections()

  updateDataField(dataField) {
    const dataFieldIdx = findIndex(this.clinicDataFields, { id: dataField.id });

    this.clinicDataFields.splice(dataFieldIdx, 1, dataField);
  }, // updateDataField()

  updateDataFieldSection(dataFieldSection) {
    const dataFieldSectionIdx = findIndex(this.clinicDataFieldSections, { id: dataFieldSection.id });

    this.clinicDataFieldSections.splice(dataFieldSectionIdx, 1, dataFieldSection);
  }, // updateDataFieldSection()

  removeDataFieldMutation(dataFieldId) {
    const dataFieldIdx = findIndex(this.clinicDataFields, { id: dataFieldId });

    this.clinicDataFields.splice(dataFieldIdx, 1);
  }, // removeDataFieldMutation()

  removeDataFieldSectionMutation(dataFieldSectionId) {
    const dataFieldSectionIdx = findIndex(this.clinicDataFieldSections, { id: dataFieldSectionId });

    this.clinicDataFieldSections.splice(dataFieldSectionIdx, 1);
  }, // removeDataFieldSectionMutation()

  async loadClinicDataFields() {
    const auth = useAuthStore();

    if (!auth.connectedClinic.id) {
      return;
    }
    const dataFieldsDb = new DataFieldsDB(auth.connectedClinic.id);

    const dataFields = await dataFieldsDb.readAll();
    this.setClinicDataFields(dataFields);
  }, // loadClinicDataFields()

  async loadClinicDataFieldSections() {
    const auth = useAuthStore();

    if (!auth.connectedClinic.id) {
      return;
    }
    const dataFieldSectionsDb = new DataFieldSectionsDB(auth.connectedClinic.id);

    const dataFieldSections = await dataFieldSectionsDb.readAll();

    this.setClinicDataFieldSections(dataFieldSections);
  }, // loadClinicDataFieldSections()

  async loadClinicDataFieldsAndSections() {
    const auth = useAuthStore();

    if (!auth.connectedClinic.id) {
      return;
    }

    try {
      // Use Promise.all to run both actions in parallel
      await Promise.all([
        this.loadClinicDataFieldSections(),
        this.loadClinicDataFields(),
      ]);
    } catch (error) {
      console.error('Error loading clinic data fields and sections:', error);
    }
  }, // loadClinicDataFieldsAndSections()

  async addNewDataField(dataFieldData) {
    const auth = useAuthStore();

    const dataFieldsDb = new DataFieldsDB(auth.connectedClinic.id);

    const newDataField = await dataFieldsDb.create({
      createdBy: auth.userDetails.userId,
      ...dataFieldData,
    });

    this.clinicDataFields.push(newDataField);

    return newDataField;
  }, // addNewDataField()

  async addNewDataFieldSection(sectionData) {
    const auth = useAuthStore();

    const dataFieldSectionsDb = new DataFieldSectionsDB(auth.connectedClinic.id);

    const newSection = await dataFieldSectionsDb.create({
      createdBy: auth.userDetails.userId,
      ...sectionData,
    });

    this.clinicDataFieldSections.push(newSection);

    return newSection;
  }, // addNewDataFieldSection()

  async editDataField(dataFieldData) {
    const auth = useAuthStore();

    const dataFieldsDb = new DataFieldsDB(auth.connectedClinic.id);

    await dataFieldsDb.update(dataFieldData);
    this.updateDataField(dataFieldData);
  }, // editDataField()

  async editDataFieldSection(sectionData) {
    const auth = useAuthStore();

    const dataFieldSectionsDb = new DataFieldSectionsDB(auth.connectedClinic.id);

    await dataFieldSectionsDb.update(sectionData);
    this.updateDataFieldSection(sectionData);
  }, // editDataFieldSection()

  async removeDataField(dataFieldId) {
    const auth = useAuthStore();

    const dataFieldsDb = new DataFieldsDB(auth.connectedClinic.id);

    await dataFieldsDb.delete(dataFieldId);
    this.removeDataFieldMutation(dataFieldId);
  }, // removeDataField()

  async removeDataFieldSection(dataFieldSectionId) {
    const auth = useAuthStore();

    const dataFieldsSectionDb = new DataFieldSectionsDB(auth.connectedClinic.id);

    await dataFieldsSectionDb.delete(dataFieldSectionId);
    this.removeDataFieldSectionMutation(dataFieldSectionId);
  }, // removeDataField()

  async login() {
    await this.loadClinicDataFieldsAndSections();
  }, // login()

};
